/*
src/ui-panels/TrackPanel.js
wgbh-skydiagram-testing
astro.unl.edu
2019-06-16
*/


import * as React from 'react';

import {FormGroup, Checkbox, Slider} from '@blueprintjs/core';

import {ColorPicker} from '../ui-misc/ColorPicker.js';


export class TrackPanel extends React.Component {


	constructor(props) {
		super(props);

		// Params are specific properties of the ParamsManager that use the getParams and setParams methods.
		// The paramsOfInterest object is used to fetch only the params used by this panel.
		// The propertiesOfInterest array includes the names of all params of interest, plus any additional
		//	properties of interest that are not params. It is used to determine if the panel needs to be re-rendered.
		// Examples: width is a param, but sunImage is not. Both are properties.
		this._paramsOfInterest = {showTrack: null, trackColor: null, trackWidth: null, trackPath: null, trackCutoutSize: null};
		this._propertiesOfInterest = [];
		for (const key in this._paramsOfInterest) {
			this._propertiesOfInterest.push(key);
		}

		this.forceRender = this.forceRender.bind(this);
		this.paramsManagerChangeCallback = this.paramsManagerChangeCallback.bind(this);
		this.handleSetParams = this.handleSetParams.bind(this);

		this._paramsMan = this.props.workspace.getParamsManager();

		this._paramsMan.registerCallback('change', this.paramsManagerChangeCallback);
		
		this.state = {
			dirtyCount: 1,
		};
	}


	forceRender() {
		this.setState(state => ({dirtyCount: state.dirtyCount+1}));
	}

	paramsManagerChangeCallback(type, caller, data) {
		// Re-render only if any of the properties of interest have changed.
		for (const key of this._propertiesOfInterest) {
			if (data.newValues.hasOwnProperty(key)) {
				this.forceRender();
				return;
			}
		}
	}

	handleSetParams(p) {
		this._paramsMan.setParams(p);
	}


	render() {

		let params = this._paramsMan.getParams(this._paramsOfInterest);

		if (params.trackPath.length !== 1) {
			console.error('There is more than one trackPath point.');
		}
		
		return (

			<div style={{maxWidth: "750px", margin: "30px auto"}}>

				<Checkbox label="Show Track"
					checked={params.showTrack}
					onChange={e => this.handleSetParams({showTrack: e.target.checked})}
					style={{margin: "0 0 20px 0"}} />

				<ColorPicker label="Track Color" color={params.trackColor} allowAlpha={true}
					onChange={value => this.handleSetParams({trackColor: value})} />

				<FormGroup label="Track Width" labelFor="track-width-slider">
					<Slider id="track-width-slider" min={0.5} max={5} stepSize={0.01} labelStepSize={1.0}
						onChange={value => this.handleSetParams({trackWidth: value})} value={params.trackWidth} />
				</FormGroup>

				<FormGroup label="Track Shape" labelFor="track-shape-slider">
					<Slider id="track-shape-slider" min={0.0} max={0.8} stepSize={0.001} labelStepSize={0.1}
						onChange={value => this.handleSetParams({trackPath: [{x: value, y: 1.0}]})} value={params.trackPath[0].x} />
				</FormGroup>

				<FormGroup label="Sun & Moon Cutouts Size" labelFor="track-cutout-size-slider">
					<Slider id="track-cutout-size-slider" min={1.0} max={2.0} stepSize={0.01} labelStepSize={0.2}
						onChange={value => this.handleSetParams({trackCutoutSize: value})} value={params.trackCutoutSize} />
				</FormGroup>
			
			</div>
		);
	}

}


